module.exports = __webpack_public_path__ + "static/media/right-sign-resavation.8619d814.png";